export default __webpack_public_path__ + "static/media/megane-rs-gallery-3.c02db035.jpg";